"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootPublicPageSagas = void 0;
var RootPageSaga_1 = require("@/pages/common/sagas/RootPageSaga");
var ContactSaga_1 = require("@/pages/search/sagas/ContactSaga");
var EnquireSaga_1 = require("@/pages/search/sagas/EnquireSaga");
var LoginSaga_1 = require("@/pages/common/sagas/LoginSaga");
var ExistingLoginSaga_1 = require("@/pages/search/sagas/ExistingLoginSaga");
var SignupSaga_1 = require("@/pages/common/sagas/SignupSaga");
var RecaptureSaga_1 = require("@/pages/search/sagas/RecaptureSaga");
var BreadcrumbSaga_1 = require("@/pages/search/sagas/BreadcrumbSaga");
var FacebookLoginSaga_1 = require("@/pages/search/sagas/FacebookLoginSaga");
var effects_1 = require("redux-saga/effects");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var SfavAction_1 = require("@/pages/search/actions/sfilter/SfavAction");
var watchOnPublicPageLogoutSucccess = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_LOGOUT_SUCCESS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.removeAllHash)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SfavAction_1.default.setSaveSearchList([]))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.rootPublicPageSagas = {
    rootPageSagas: RootPageSaga_1.rootPageSagas,
    facebookLoginSagas: FacebookLoginSaga_1.facebookLoginSagas,
    contactSagas: ContactSaga_1.contactSagas,
    enquireSagas: EnquireSaga_1.enquireSagas,
    userLoginSagas: LoginSaga_1.userLoginSagas,
    signupSagas: SignupSaga_1.signupSagas,
    existingLoginSagas: ExistingLoginSaga_1.existingLoginSagas,
    recaptureSagas: RecaptureSaga_1.recaptureSagas,
    breadcrumbSagas: BreadcrumbSaga_1.breadcrumbSagas,
    watchOnPublicPageLogoutSucccess: watchOnPublicPageLogoutSucccess,
};
